import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import UtilisationKpiIndicator from "../components/UtilisationKpiIndicator";
import UtilisationKpiTable from "../components/UtilisationKpiTable";

export default function UtilisationKpi({}){
	
	
	
	const thisContainer = {
		display:'flex',
		width:"100%",
		backgroundColor:"white",
		height:"160px"
	};
	
	const keyPanel = {
		display:"flex",
		flexDirection:"column"
	};
	
	const facilityTitle = {
		display:"flex",
		fontSize:"16px",
		color:"black",
		height:"40px",
		alignItems:"center",
		paddingLeft:"15px"
	};
	
	const selectRow = {
		display:"flex",
		height:"30px",
		alignItems:"center"
	};
	
	const selectRowTitle = {
		display:"flex",
		width:"100px",
		fontSize:'12px',
		color:"black",
		paddingLeft:"15px"
	};
	
	const selectStyle = {
		display:"flex",
		height:"25px",
		paddingLeft:"10px",
		border:"1px solid lightgrey",
		borderRadius:"5px",
		width:"200px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={keyPanel}>
				<div style={facilityTitle}>
					Worsley Building
				</div>
				<div style={selectRow}>
					<div style={selectRowTitle}>
						Start Date
					</div>
					<select style={selectStyle}>
						<option>Select</option>
					</select>
				</div>	
				<div style={selectRow}>
					<div style={selectRowTitle}>
						End Date
					</div>
					<select style={selectStyle}>
						<option>Select</option>
					</select>
				</div>	
				<div style={selectRow}>
					<div style={selectRowTitle}>
						Space Type
					</div>
					<select style={selectStyle}>
						<option>Select</option>
					</select>
				</div>	
			</div>
			<UtilisationKpiIndicator
				id="utilisationkpiindicatorall"
				title="All Spaces"
				number="338"
				utilisation="80"
			/>
			<UtilisationKpiIndicator
				id="utilisationkpiindicatorworkstations"
				title="Workstations"
				number="267"
				utilisation="70"
			/>
			<UtilisationKpiIndicator
				id="utilisationkpiindicatormeeting"
				title="Multiple Occ"
				number="34"
				utilisation="60"
			/>
			<UtilisationKpiTable/>
		</div>
	);
}